import Headroom from 'headroom.js';

export default function initSiteHeader() {
  const $header = document.getElementById('site-header');
  const config = {
    tolerance: {
      up: 5,
      down: 10,
    },
    classes : {
      initial : "site-header--init",
      pinned : "site-header--pinned",
      unpinned : "site-header--unpinned",
      top : "site-header--top",
      notTop : "site-header--not-top",
      bottom : "site-header--bottom",
      notBottom : "site-header--not-bottom",
      frozen: "site-header--frozen",
    },
  }

  const header = new Headroom($header, config);

  header.init()
}
